import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { BeatLoader } from 'react-spinners'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'

const AppSpin = ({height, size}) => {
	const { theme } = useDefaultComponentTools()
	return (
		<Box sx={{
			alignItems: 'center',
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			minHeight: height || 0
		}}>
			<BeatLoader
				size={size || 20}
				margin={3}
				speedMultiplier={1}
				color={theme.palette.blue} />
		</Box >
	)
}

AppSpin.propTypes = {
	height: PropTypes.string,
	size: PropTypes.number
}

export { AppSpin }
